import { render, staticRenderFns } from "./BankReadiness.vue?vue&type=template&id=a12055b8&scoped=true"
import script from "./BankReadiness.vue?vue&type=script&lang=js"
export * from "./BankReadiness.vue?vue&type=script&lang=js"
import style0 from "./BankReadiness.vue?vue&type=style&index=0&id=a12055b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12055b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
